import React from "react";
import {Star} from "../star/Star";

const StarRating = ({rating, totalStars = 5}) => {
    return (
        <div style={{display: "flex", gap: "5px"}}>
            {Array.from({length: totalStars}, (_, index) => (
                <Star key={index} filled={index < rating}/>
            ))}
        </div>
    );
};

export {StarRating};
